import React from 'react';
import './App.css';
import { RouterProvider, createBrowserRouter, Outlet } from 'react-router-dom';
import { Navigate } from "react-router-dom";

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import PracticeAreas from './pages/PracticeAreas'; 
import ClientIntake from './pages/ClientIntake';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';
import MeetTheTeam from './pages/MeetTheTeam';
import TeamMemberProfile from './pages/TeamMemberProfile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TimeClock from './pages/TimeClock';

const Layout = () => {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/staff",
    element: <TimeClock />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/practice-areas",
        element: <PracticeAreas />,
      },
      {
        path: "/client-intake",
        element: <ClientIntake/>,
      },
      {
        path: "/blog",
        element: <Blog/>,
      },
      {
        path: "/blog/:postId",
        element: <BlogPost/>,
      },
      {
        path: "/team",
        element: <MeetTheTeam/>,
      },
      {
        path: "/team/:memberId",
        element: <TeamMemberProfile/>,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy/>,
      },
      { // redirects for old cached links
        path: "/book-online",
        element: <Navigate to="/client-intake" replace />,
      },
      {
        path: "/casey",
        element: <Navigate to="/team/casey-daggett" replace />,
      },
      {
        path: "/bill",
        element: <Navigate to="/team/bill-petti" replace />,
      },
      {
        path: "/customer-intake",
        element: <Navigate to="/client-intake" replace />,
      },
      {
        path: "/meet-the-team",
        element: <Navigate to="/team" replace />,
      },
      {
        path: "*",
        element: <NotFound/>,
      }
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;